import React from 'react'
import Logo from '@bt-react/components/Logo'
import componentStyles from './Splash.module.scss'

class Splash extends React.Component {

  render () {

    return <div className={componentStyles[`splash`]}>
      <div className={componentStyles[`splash__dialogue-ending`]}>
        {this.props.children}
      </div>
      <Logo className={componentStyles[`splash__logo`]} />
    </div>

  }

}

export default Splash
